export const phoneNumberValidator = (value: string, translate: CallableFunction) => {
  if (!value) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.invalidUSPhoneNumber");
  }

  const sanitizedValue = value.replaceAll("-", "").replaceAll(".", "").replaceAll(" ", "").trim();

  if (!/^\d+$/.test(sanitizedValue)) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.onlyNumbersAllowed");
  }

  if (sanitizedValue.length !== 10) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.invalidUSPhoneNumber");
  }

  return undefined;
};
